export const SIGNATURE_DEFAULTS = {
  logo: 'https://opensense.s3.amazonaws.com/designer/logo.svg',
  photo: 'https://opensense.s3.amazonaws.com/designer/headshot.svg',
  name: 'John Smith',
  title: 'Director of Marketing',
  email: 'john.smith@opensense.com',
  address: '123 Main St, Palo Alto, CA',
  phone: '(555) 419-1982',
  mobile: '(555) 710-5868',
  office: '(555) 813-3991 Ext: 123',
  website: 'https://www.opensense.com',
  // Social + CTA samples exist ONLY for the async Liquid gallery preview
  // (loadSignatureModalTemplates): social values keep conditional blocks visible, while CTA
  // values provide sample links. They are preview/editor-only and never seeded into a production signature.
  // sgsender is intentionally NOT here — it lives as a helper-local constant inside
  // loadSignatureModalTemplates (Task 0.4) to keep the sample sender out of this map.
  facebook: 'https://facebook.com/opensense',
  instagram: 'https://instagram.com/opensense',
  linkedin: 'https://linkedin.com/company/opensense',
  twitter: 'https://twitter.com/opensense',
  meeting: 'https://www.opensense.com',
  review: 'https://www.opensense.com',
  hiring: 'https://www.opensense.com',
  support: 'https://www.opensense.com',
  account: 'https://www.opensense.com'
};
